import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = a(
  (s, r) => /* @__PURE__ */ o.jsx(
    e,
    {
      ref: r,
      ...s,
      image: (t) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...t,
          children: /* @__PURE__ */ o.jsx("path", { fill: "currentColor", d: "M0 6v4h16V6z" })
        }
      )
    }
  )
);
i.displayName = "DashIcon";
export {
  i as DashIcon,
  i as default
};
//# sourceMappingURL=index.js.map
